import { Page } from "../../frameworks/joy/layouts/page";
import { WhoAmIContainer } from "./container";

export const WhoAmIPage = () => {
  return (
    <Page>
      <WhoAmIContainer />
    </Page>
  );
};
